module.exports = __webpack_public_path__ + "img/tip2.f0322b49.png";